import { Task } from 'redux-saga';
import { cancel, fork, select, take, put } from 'redux-saga/effects';
import { SetDateAction, seek } from 'actions/monitoringActions';
import { getLayout, getCameraFromCell, getCell } from 'selectors/monitoringSelectors';
import { isLoggedIn } from 'selectors/shellSelectors';
import { CellIndex, MaxCells, CellState } from 'types';
import { timelineRequestSaga } from './timelineRequestSaga';

export function* setDateWatcher() {
    // Allow each cell to have its own task to fetch timeline information
    const cellTasks: Task[] = Array.apply(null, Array(MaxCells)); // stupid syntax, thanks JavaScript.

    while (true) {
        // Wait for a date change
        const action: SetDateAction = yield take('SET_DATE');
        const loggedIn = yield select(isLoggedIn);
        if (!loggedIn) continue;

        const { date, preserveTimeOfDay } = action.payload;

        if (preserveTimeOfDay) {
            yield fork(seekAllOccupiedCellsSaga, date);
        }

        const nCells = yield select(getLayout);

        for (let i = 0; i < nCells; i++) {
            // Cancel the existing task for that cell (if there was one)
            if (cellTasks[i]) {
                yield cancel(cellTasks[i]);
            }

            const cellIndex = (i + 1) as CellIndex;
            const camera = yield select(getCameraFromCell, { cellIndex });
            if (camera) {
                // Start a task to fetch the timeline information for this cell
                const { deviceId } = camera;
                cellTasks[cellIndex] = yield fork(timelineRequestSaga, deviceId, cellIndex, date);
            }
        }
    }
}

function* seekAllOccupiedCellsSaga(utcDate: Date) {
    const utcTime = utcDate.valueOf(); // KILL

    const nCells = yield select(getLayout);
    for (let cellIndex: CellIndex = 1; cellIndex <= nCells; cellIndex = (cellIndex + 1) as CellIndex) { // Skip cell 0 (the Change Image cell)
        const whichCell = { cellIndex };
        const { streamId }: CellState = yield select(getCell, whichCell);
        if (streamId) {
            // TODO: need to figure out what to set streamPosition to... e.g. change date but keep same time of day?
            //const utcTime = yield select(getStreamPosition, whichCell);
            yield put(seek({ cellIndex, utcTime }));
        }
    }
}



// WEBPACK FOOTER //
// ./src/sagas/monitoring/setDateWatcher.ts